export class InvestorsEnvironment {
  public static getName = () => 'benzinga-investors';
  public static getEnvironment = (env: Record<string, string>) => ({
    key: env.key ?? '',
    token: env.token ?? '',
    url: new URL(env.url ?? 'https://data-api-pro.benzinga.com/'),
  });
}
